import { render, staticRenderFns } from "./ParamsDialog.vue?vue&type=template&id=a1facd44&scoped=true"
import script from "./ParamsDialog.vue?vue&type=script&lang=js"
export * from "./ParamsDialog.vue?vue&type=script&lang=js"
import style0 from "./ParamsDialog.vue?vue&type=style&index=0&id=a1facd44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1facd44",
  null
  
)

export default component.exports